import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import Modal from '@core/components/Modal/Modal';
import UseModal from 'hooks/use-modal';
import { useMutation } from 'react-query';
import { Notification } from 'iconsax-react';
import { getErrorText } from 'utils/geterrortext';
import { publicMetaDataServices } from 'services/cv';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import SwitchInput from '@core/components/switchinput/SwitchInput';
import ActionButton from '@core/components/actionbutton/ActionButton';

import { InfoCircle } from 'iconsax-react';

import classes from './ProfileSetting.module.scss';

const ProfileSetting = ({ data, refetchCertificateMetaData, toast }) => {
    const { show, showModal, destroyModal } = UseModal();
    const { mutate } = useMutation(publicMetaDataServices.PUT, {
        onSuccess: (data) => {
            refetchCertificateMetaData(data.data.is_public);

        },
        onError: (error) => {
            toast(getErrorText(error), 'alert');
        }
    });
    const handleChange = (e) => {
        if (e.target.checked)
            mutate({ is_public: e.target.checked });
        else
            showModal();
    }
    const handleInvisibleProfile = () => {
        mutate({ is_public: false });
        destroyModal();
    }
    return (
        <>
            {/* <div className={classes['title']}>
                <Notification size={24} /> Profile Setting
            </div> */}
            <div className={classes['item-wrapper']}>
                <div className={classes['item']}>
                    <span>
                        <h3>Public Visibility</h3>
                        <Tooltip title="Your profile is publicly visible and people can access it by searching your name or sharing your profile URL." placement="top-start">
                            <InfoCircle size={16} color='#CCCBC9' variant='Bold' />
                        </Tooltip>                        
                        {/* <p>Your profile is publicly visible. People can find it by searching your name or using your profile URL.</p> */}
                    </span>
                    <SwitchInput
                        handleChange={handleChange}
                        value={data.is_public}
                    />
                </div>
            </div>
            <Modal
                type={MOBILE_SLIDE_UP}
                show={show}
                closeHandler={destroyModal}
                header={false}
            >
                <div
                    className={`${classes["modal-confirmation"]} d-flex flex-column align-items-start`}
                    style={{ minWidth: '50vw' }}
                >
                    <h3>Public Visibility</h3>
                    <p>By making the profile invisible, the recruiters who applied with your profile will not be able to see it.</p>
                    <div className='d-flex justify-content-end gap-4 w-100 mt-4'>
                        <ActionButton kind='blank' onClick={() => destroyModal()}>Cancel</ActionButton>
                        <ActionButton onClick={() => handleInvisibleProfile()}>Invisible anayway</ActionButton>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ProfileSetting;